import { api } from "@/lib/api";

export async function fetchBusiness() {
  const { data } = await api.get("/admin/business");
  return data;
}

export async function fetchSubscriptions() {
  const { data } = await api.get("/admin/subscriptions");
  return data;
}

export async function fetchAiUsage() {
  const { data } = await api.get("/admin/ai-usage");
  return data;
}

export async function fetchPaymentEvents() {
  const { data } = await api.get("/admin/payment-events");
  return data.events;
}

export async function deleteUser(userId) {
  const { data } = await api.delete(`/admin/users/${userId}`);
  return data;
}

export async function deleteCode(codeId) {
  const { data } = await api.delete(`/admin/codes/${codeId}`);
  return data;
}
